import { Component, ElementRef, Inject, Input, OnInit, ViewChild } from '@angular/core';
import { SharedService } from '../service/shared.service';
import Swal from 'sweetalert2';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { DomSanitizer, SafeHtml, SafeResourceUrl } from '@angular/platform-browser';
import { renderAsync } from 'docx-preview';
import * as XLSX from 'xlsx';
import { saveAs } from 'file-saver';
export interface DialogData {
  // if true -> show $fileBlob directly
  // if false -> Call API using $fileToken to return Blob file
  isBlob: boolean;
  fileToken?: string;
  fileBlob?: File;
  name?: string;
}

@Component({
  selector: 'app-preview-attachment',
  templateUrl: './preview-attachment.component.html',
  styles: [`

.preview-wrapper {
  width: 100%;
  position: relative;
}

/* Word */
::ng-deep .docx-viewer {
  width: 100%;
  // height: 650px;
  overflow-y: auto;
  // border: 1px solid #ccc;
  background-color: #f5f5f5;
}

::ng-deep .docx-viewer-wrapper {
  padding: 0px !important;
}

::ng-deep .docx-viewer table {
  max-width: 100% !important;
  width: 100% !important;
}

::ng-deep .docx-viewer-wrapper .docx-viewer {
  /* padding-left: 0px !important;
            padding-right: 0px !important; */
  box-shadow: none !important;
  width: 100% !important;
}

::ng-deep .docx-viewer-wrapper * {
  max-width: 100%;
  /* margin-left: 0px !important;
            margin-right: 0px !important; */
}

::ng-deep .docx-viewer_header div {
  width: 100% !important;
  height: auto !important;
}

::ng-deep .docx-viewer_footer div {
  width: 100% !important;
  height: auto !important;
}

/* Excle */
.sheet-tabs {
  display: flex;
  gap: 4px;
  background: #f1f1f1;
  padding: 5px 5px 0 5px;
  border: 1px solid #ccc;
  border-bottom: none;
}

.sheet-tabs button {
  padding: 6px 12px;
  border: 1px solid #ccc;
  background: #e1e1e1;
  cursor: pointer;
}

.sheet-tabs button.active {
  background: #fff;
  border-bottom: 2px solid #fff;
  font-weight: bold;
}

.excel-container {
  width: 100%;
  height: 600px;
  overflow: auto;
  border: 1px solid #ccc;
  background: #fff;
  padding: 1rem;
}

::ng-deep .excel-container table {
  border-collapse: collapse;
  width: 100%;
  font-family: Arial, sans-serif;
  font-size: 13px;
}

::ng-deep .excel-container th,
::ng-deep .excel-container td {
  border: 1px solid #ddd;
  padding: 6px 10px;
  white-space: nowrap;
}

::ng-deep .excel-container th {
  background-color: #8ca2cbff;
}
    `]
})
export class PreviewAttachmentComponent implements OnInit {



  LoadedFile: Blob;
  loading: boolean = true;
  htmlString: any;
  htmlStringUrl: string;

  // excel 
  workbook?: XLSX.WorkBook;
  sheetNames: string[] = [];
  activeSheetName: string = '';




  @ViewChild('ExcelTableElement', { static: true }) ExcelTableElement!: ElementRef;
  @ViewChild('WordTableElement', { static: true }) WordTableElement!: ElementRef;

  constructor(private service: SharedService,
    private dialogRef: MatDialogRef<PreviewAttachmentComponent>,
    @Inject(MAT_DIALOG_DATA) public data: DialogData,
    private sanitizer: DomSanitizer
  ) { }

  ngOnInit(): void {
    if (this.CanPreview) {
      this.loadFile();
    } else {
      this.dialogRef.close();
      Swal.fire('Error', 'This file type is not supported to preview.', 'error');
    }
  }



  // ************* load file from api ************
  loadFile() {
    if (this.data.isBlob) {
      this.LoadedFile = this.data.fileBlob;
      this.handlePreview();
      return;
    }

    this.loading = true;
    this.service.filePreview(this.data.fileToken).subscribe((response: Blob) => {
      this.LoadedFile = response;
      this.handlePreview();
      // this.loading = false;
    }, (err) => {
      this.loading = false;
      this.dialogRef.close();
      Swal.fire('Error', "File doesn't exist.", 'error');
    });
  }

  // ************* handle preview ************
  async handlePreview() {
    this.loading = true;

    try {
      // Revoke previous object URL if one exists to prevent memory leaks
      if (this.htmlStringUrl) {
        URL.revokeObjectURL(this.htmlStringUrl);
      }

      if (this.IsImage || this.IsPdf || this.IsVideo) {
        // Store raw string URL for cleanup, bind sanitized URL to template
        this.htmlStringUrl = URL.createObjectURL(this.LoadedFile);
        this.htmlString = this.sanitizer.bypassSecurityTrustResourceUrl(this.htmlStringUrl);
        this.loading = false;
      }
      else if (this.IsExcel) {
        await this.excelFileHandler();
      }
      else if (this.IsDoc) {
        await this.wordFileHandler();
      }
      else {
        this.loading = false;
        this.dialogRef.close();
        Swal.fire('Warning', 'Unsupported file format for preview.', 'warning');
      }
    } catch (error) {
      this.loading = false;
      this.dialogRef.close();
      Swal.fire('Error', 'An error occurred while generating the preview.', 'error');
    }
  }

  // ************* word file handler ************
  async wordFileHandler() {
    try {
      // Convert Blob to ArrayBuffer
      const arrayBuffer = await new Response(this.LoadedFile).arrayBuffer();

      // Render DOCX into DOM container
      await renderAsync(arrayBuffer, this.WordTableElement.nativeElement, undefined, {
        className: 'docx-viewer',
        inWrapper: true,
        ignoreWidth: false,
        ignoreHeight: false
      });
    } catch (err) {
      this.dialogRef?.close();
      Swal.fire('Error', 'Failed to render Word document.' + err, 'error');
    } finally {
      this.loading = false;
    }
  }

  // ************* excel file handler ************
  async excelFileHandler() {
    try {
      const arrayBuffer = await new Response(this.LoadedFile).arrayBuffer();
      this.workbook = XLSX.read(arrayBuffer, { type: 'array' });

      this.sheetNames = Array.from(this.workbook.SheetNames);
      if (this.sheetNames.length > 0) {
        this.switchSheet(this.sheetNames[0]);
      }
    } catch (err) {
      this.dialogRef?.close();
      Swal.fire('Error', 'Failed to parse Excel file.' + err, 'error');
    } finally {
      this.loading = false;
    }
  }

  // Memory cleanup when component is destroyed
  ngOnDestroy(): void {
    if (this.htmlStringUrl) {
      URL.revokeObjectURL(this.htmlStringUrl);
    }
  }
  // ************* switch sheet ************
  switchSheet(sheetName: string): void {
    if (!this.workbook) return;
    this.activeSheetName = sheetName;
    const worksheet = this.workbook.Sheets[sheetName];

    // Generate HTML string from worksheet
    const rawHtml = XLSX.utils.sheet_to_html(worksheet);

    // Bypass Security Trust to permit innerHTML rendering
    this.htmlString = rawHtml;
  }

  // download file
  onDownload() {
    const model = {
      file_download: this.data.fileToken,
    };
    this.service.documentDownloader(model).subscribe((data) => {
      const blob = new Blob([data]);
      // console.log(data.data.name);
      console.log(blob);
      saveAs(blob, `${this.data.name}`);
    });
  }

  // ************* getters for file type ************
  get IsImage() {
    const imageExtensions = ['jpg', 'jpeg', 'png', 'gif', 'tiff', 'bmp', 'svg'];
    return imageExtensions.includes(this.fileType);
  }

  get IsExcel() {
    const excelExtensions = ['xlsx', 'xls', 'csv'];
    return excelExtensions.includes(this.fileType);
  }

  get IsPdf() {
    const pdfExtensions = ['pdf'];
    return pdfExtensions.includes(this.fileType);
  }

  get IsDoc() {
    const docExtensions = ['doc', 'docx'];
    return docExtensions.includes(this.fileType);
  }

  get IsVideo() {
    const videoExtensions = ['mp4', 'webm'];
    return videoExtensions.includes(this.fileType);
  }

  // ************* get file type ************
  get fileType(): string {
    if (this.data.isBlob) {
      return this.data.fileBlob?.name.split('.').pop()?.toLowerCase() || '';
    } else {
      return this.data.fileToken?.split('.').pop()?.toLowerCase() || '';
    }
  }

  // ************* get to check if the file can be previewed ************
  get CanPreview() {
    return this.IsExcel || this.IsPdf || this.IsDoc || this.IsImage || this.IsVideo;
  }

}
